export default __webpack_public_path__ + "static/media/imgSpinVi.03fa1be6.png";